// extracted by mini-css-extract-plugin
export var container = "_8r-0";
export var containerTopRight = "_8r-1";